<div>
	<pannel *ngFor="let traduction of traductions" [title]="traduction.fr"
		[expandable]="true" [folded]="!traduction.checked"
		[ngClass]="highlightedSections.indexOf(traduction.id) > -1 ? 'highlightable' : ''">
	<table class="analyse-table">
		<tr>
			<!-- NATURE -->
			<td class="table-cell nature-cell">
				<table mat-table [dataSource]="traduction.activites || []">
					<ng-container matColumnDef="selected">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let child">
							<mat-checkbox color="primary" [(ngModel)]="child.checked" (change)="onChangeActivite(traduction)" [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"></mat-checkbox>
						</td>
					</ng-container>
					<ng-container matColumnDef="fr">
						<th mat-header-cell *matHeaderCellDef>Nature du risque</th>
						<td mat-cell *matCellDef="let child">{{ child.fr }}</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="['selected', 'fr']"></tr>
					<tr mat-row *matRowDef="let row; columns: ['selected', 'fr']"
						[class.group-end]="row.isGroupEnd"></tr>
				</table>
			</td>

			<!-- FACTEUR + MESURES + RESPONSABILITY groupés -->
			<td class="table-cell combined-cell">
				<table class="inner-table">
					<colgroup>
						<col class="col-facteur">
						<col class="col-mesure">
						<col class="col-resp">
					</colgroup>

					<thead>
						<tr class="inner-header">
							<th class="th-facteur"><div class="th-label">{{ label1 }}</div></th>
							<th class="th-mesure">{{ label2 }}</th>
							<th class="th-resp">A la charge de</th>
						</tr>
					</thead>

					<tbody>
						<tr class="group-row" *ngFor="let g of traduction.groupes; let last = last"
							[class.group-end]="!last">

							<!-- FACTEURS du groupe -->
							<td class="facteur-cell">
								<div class="facteur-item" *ngFor="let f of g.facteurs">
									<mat-checkbox color="primary" [(ngModel)]="f.checked"
										name="risque_selected_{{traduction.id}}_{{f.id}}"
										[disabled]="noneSelected(traduction.activites) || currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
										(change)="onChangeRiskOrImpact(traduction)">
									</mat-checkbox>
									<span class="item-label">{{ f.fr }}</span>
								</div>
							</td>

							<!-- MESURES + RESPONSABILITE du groupe -->
							<td class="mesures-cell" colspan="2">
								<table class="mesures-inner">
									<tr class="mesure-row" *ngFor="let m of g.mesures; let i = index">
										<td class="m-cb">
											<mat-checkbox color="primary" [(ngModel)]="m.checked"
												name="mesure_selected_{{traduction.id}}_{{g.key}}_{{i}}"
												[disabled]="isGroupeDisabled(g, traduction) || currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
												(change)="onChangeMesurePrevention(m, traduction)">
											</mat-checkbox>
										</td>

										<td class="m-label">
											<ng-container *ngIf="!isAutre(m); else autreTpl">{{ m.fr }}</ng-container>
											<ng-template #autreTpl>
												<mat-form-field appearance="outline" class="autre-field" [class.autre-invalid]="m.checked && !(m.texteLibre || '').trim()">
													<textarea matInput rows="3"
														[placeholder]="m.fr"
														[(ngModel)]="m.texteLibre"
														name="mesure_autre_{{traduction.id}}_{{g.key}}_{{i}}"
														[disabled]="!m.checked
																	|| currentPaInstance.etat == paEtats.SIGNE
																	|| currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
														(ngModelChange)="onChangeTexteAutre(traduction)"></textarea>
												</mat-form-field>
											</ng-template>
										</td>

										<td class="m-resp">
											<mat-checkbox color="primary"
												[checked]="m.responsibility === ResponsabiliteDocument.EU || m.responsibility === ResponsabiliteDocument.BOTH"
												[disabled]="!m.checked || currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
												(change)="onChangeChargeEU(m, traduction)">EU</mat-checkbox>

											<mat-checkbox color="primary"
												[checked]="m.responsibility === ResponsabiliteDocument.EE || m.responsibility === ResponsabiliteDocument.BOTH"
												[disabled]="!m.checked || currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
												(change)="onChangeChargeEE(m, traduction)">EE</mat-checkbox>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</td>
		</tr>
	</table>
	</pannel>
</div>
<document-pa-step-actions [documentPaButtons]="actionButtons" (onButtonPressed)="performAction($event)"></document-pa-step-actions>